<template>
    <dropdown :triggers="[]" :shown="isOpen" offset="160" :auto-hide="false">
        <a ref="link" :class="classes" @click="toggle">
            <fa-icon v-if="icon" ref="icon" :icon="icon" :count="iconCount" />
            <span v-if="text" v-text="text" />
        </a>

        <template #popover>
            <div ref="dropdown" class="dropdown messages-attach-files messages-upload-files">
                <div class="dropdown-body dropdown-body--static">
                    <div class="dropdown-content">
                        <slot></slot>
                    </div>
                </div>
            </div>
        </template>
    </dropdown>
</template>

<script>
import { Dropdown } from 'v-tooltip';

export default {
    emits: ['icon-click'],
    
    components: {
        Dropdown,
    },

    props: {
        icon: { type: [Object, Array, String], default: null },
        text: { type: String, default: null },
        iconCount: { type: Number, default: null },
    },

    data: () => ({
        isOpen: false,
    }),

    computed: {
        classes() {
            let classes = {};

            classes['is-active'] = this.isOpen;

            return classes;
        },
    },

    methods: {
        hide() {
            this.isOpen = false;
        },

        show() {
            this.isOpen = true;
        },

        toggle() {
            this.isOpen = !this.isOpen;
        },

        handleDocumentClick(e) {
            if (!this.$refs.dropdown.contains(e.target) && !this.$refs.link.contains(e.target)) {
                this.hide();
            }
        },

        onBeforeActivate(e) {
            if (this.isIconClick(e)) {
                this.$emit('icon-click', e);

                return false;
            }
        },

        isIconClick(e) {
            if (
                !this.$options._parentListeners ||
                !this.$options._parentListeners.hasOwnProperty('icon-click')
            ) {
                return false;
            }

            return (
                [...this.$refs.icon.$el.children].findIndex((item) => {
                    return item === e.target;
                }) !== -1
            );
        },
    },

    mounted() {
        document.addEventListener('click', this.handleDocumentClick);
    },

    destroy() {
        document.removeEventListener('click', this.handleDocumentClick);
    },
};
</script>
